import { render, staticRenderFns } from "./Detail1.vue?vue&type=template&id=ba51f0d8&"
import script from "./Detail1.vue?vue&type=script&lang=js&"
export * from "./Detail1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports